import React from 'react'
import { css } from '@emotion/react'

import debug from 'util/debug'
import { Dropdown } from 'util/ui'

import Avatar from 'components/Avatar'
import DebugButton from 'components/DebugButton'
import LegacyLink from 'components/LegacyLink'

export default function UserItem({
  canAccessAdmin,
  className,
  currentUser,
  handleLogout,
  debugFrontend,
}) {
  return (
    <Dropdown
      className={className}
      css={css`
        // Hack-ish way to hide dropdown icon
        .dropdown.icon {
          display: none !important;
        }
      `}
      trigger={<Avatar size={32} borderRadius={4} actor={currentUser} />}
    >
      <Dropdown.Menu>
        <Dropdown.Header content="Settings" />
        <Dropdown.Item as={LegacyLink} path="settings/profile">
          Update your profile
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          href="https://help.groovehq.com/help"
          target="_blank"
          rel="noopener
          noreferrer"
        >
          Groove Knowledge Base
        </Dropdown.Item>
        {canAccessAdmin && (
          <Dropdown.Item
            as={LegacyLink}
            skipModal
            async={false}
            path="/admin/accounts"
          >
            Go to admin
          </Dropdown.Item>
        )}
        {(debug.enabled || debugFrontend) && <DebugButton as={Dropdown.Item} />}
        <Dropdown.Item onClick={handleLogout}>Logout</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}
